<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">巡查计划</div>
    </div>
    <div class="modul-search">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="设施名称">
          <el-select
            v-model="bridgeUuid"
            @change="bridgeChange"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in bridgeData"
              :key="index"
              :label="item.bridgeName"
              :value="item.bridgeUuid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="time"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="timeChange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="归属区域">
          <el-select
            v-model="form.ascriptionName"
            filterable
            clearable
            placeholder="请选择归属区域"
            style="width: 100%"
          >
            <el-option label="诸暨市" value="诸暨市"></el-option>
            <!-- <el-option label="康乾街道"
                       value="康乾街道"></el-option>
            <el-option label="舞阳街道"
                       value="舞阳街道"></el-option>
            <el-option label="阜溪街道"
                       value="阜溪街道"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="tableReq(1)">查询</el-button>
          <el-button type="primary" @click="xunJianClick()">批量巡检</el-button>
        </el-form-item>
      </el-form>
      <!-- <el-button @click="editRow" style="float: right;">新增</el-button> -->
    </div>
    <el-table
      class="tableStyle"
      v-loading="loading"
      ref="multipleTable"
      height="calc(100vh - 350px)"
      border
      style="width: 100%"
      :data="tableData"
      @selection-change="handleSelectionChange"
      :header-cell-style="{
        background: '#FAFAFA',
        color: '#000000',
        'text-align': 'left'
      }"
    >
      <el-table-column align="left" type="selection" width="50px"></el-table-column>
      <el-table-column
        label="序号"
        align="left"
        type="index"
        width="50px"
      ></el-table-column>
      <el-table-column prop="bridgeName" label="设施名称" align="left"></el-table-column>
      <el-table-column
        prop="departmentName"
        label="养护单位"
        align="left"
      ></el-table-column>
      <el-table-column prop="accountName" label="巡查人员" align="left"></el-table-column>
      <el-table-column
        prop="inspectionCycle"
        label="巡察周期(天)"
        align="left"
      ></el-table-column>
      <el-table-column
        prop="inspectionCycleStart"
        label="开始时间"
        align="left"
      ></el-table-column>
      <!-- <el-table-column prop="num"
                       label="巡更点位(个)"
                       align="left"></el-table-column> -->
      <el-table-column label="操作" align="left">
        <template #default="scope">
          <el-button class="btn" type="text" @click="editRow(scope.row)">编辑</el-button>
          <!-- <el-button class="btn" type="text" @click="delRow(scope.row)">删除</el-button> -->
          <!-- <el-button class="btn"
	           type="text"
	           @click="detailsRow(scope.row)">下载</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!--  -->
    <div style="text-align: center; margin: 20px 0 0">
      <el-pagination
        @size-change="handleSizeChange"
        :hide-on-single-page="!total"
        @current-change="handleCurrentChange"
        :current-page="form.pageNum"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]"
        :page-size="form.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 点击编辑或新增弹出框 -->
    <div class="caozuotianbiao" :style="caozuoxy == true ? 'display: none;' : ''">
      <el-form class="caozuotianbiao-from" :model="FormData">
        <div class="modul-top">
          <div class="caidan-img">
            <img src="../../../assets/image/caidan.png" alt="菜单" />
          </div>
          <div class="caidan-title">巡检计划</div>
        </div>
        <div
          style="
            position: absolute;
            top: 15px;
            right: 15px;
            border-radius: 50%;
            overflow: hidden;
            width: 30px;
            height: 30px;
          "
          @click="quxiao"
        >
          <img
            src="../../../assets/image/old/删除@2x.png"
            alt="关闭"
            style="width: 100%; height: 100%"
          />
        </div>
        <el-row>
          <el-col :span="11">
            <el-form-item label="设施名称" label-width="80px">
              <el-select
                v-model="FormData.bridgeUuid"
                filterable
                placeholder="请选择"
                style="width: 100%"
                @change="bridgeChanges"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.bridgeName"
                  :value="item.bridgeUuid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="养护单位" label-width="80px">
              <el-select
                v-model="FormData.departmentUuid"
                filterable
                placeholder="请选择"
                style="width: 100%"
                @change="$set(FormData, 'accountUuid', '')"
              >
                <el-option
                  v-for="item in yangHuList"
                  :key="item.value"
                  :label="item.departmentName"
                  :value="item.departmentUuid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="巡检人员" label-width="80px">
              <el-select
                v-model="FormData.accountUuid"
                filterable
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in peopleList"
                  :key="item.value"
                  :label="item.accountName"
                  :value="item.accountUuid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="巡察周期" label-width="80px">
              <el-input
                type="text"
                v-model="FormData.inspectionCycle"
                pattern="/^[1-9]\d*$/"
              >
                <el-button slot="append"> 天 </el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="开始时间" label-width="80px">
              <!--  HH:mm:ss datetime-->
              <el-date-picker
                v-model="FormData.inspectionCycleStart"
                value-format="yyyy-MM-dd"
                type="date"
                :picker-options="startPickerOptions"
                placeholder="选择开始时间"
                align="right"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="11">
            <el-form-item label-width="80px">
              <el-button type="primary"
                         @click="xunJianSure">确定</el-button>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row v-show="true">
          <el-col :span="22">
            <div style="border-top: 1px solid #ccc; padding: 20px 0 0">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="添加巡更点"></el-form-item>
                  <el-form-item label="巡更点名" label-width="80px" prop="patrolName">
                    <el-input type="text" v-model="FormData.patrolName"></el-input>
                  </el-form-item>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="经度" label-width="80px" prop="longitude">
                        <el-input v-model="FormData.longitude" placeholder="请输入经度">
                          <el-button
                            @click="getMapClick(FormData)"
                            slot="append"
                            icon="el-icon-location-outline"
                          >
                          </el-button>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="纬度" label-width="80px" prop="latitude">
                        <el-input v-model="FormData.latitude" placeholder="请输入经度">
                          <el-button
                            @click="getMapClick(FormData)"
                            slot="append"
                            icon="el-icon-location-outline"
                          >
                          </el-button>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item style="text-align: right; margin-top: 30px">
                    <el-button type="primary" @click="postXunGeng">添加</el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label-width="80px">
                    <Map style="width: 100%; height: 200px" :facList="Mapcenter"></Map>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-form-item label="巡更点列表" v-show="false" label-width="80px"></el-form-item>
        <el-row v-show="false">
          <el-col :span="22">
            <el-form-item label-width="80px">
              <el-table
                class="tableStyle"
                border
                style="width: 100%"
                max-height="180"
                :data="bianhaoData"
                :header-cell-style="{
                  background: '#FAFAFA',
                  color: '#000000',
                  'text-align': 'left'
                }"
              >
                <el-table-column
                  label="编号"
                  align="left"
                  type="index"
                  width="50px"
                ></el-table-column>
                <el-table-column
                  label="巡更点名称"
                  prop="patrolName"
                  align="left"
                ></el-table-column>
                <el-table-column
                  label="经度"
                  prop="longitude"
                  align="left"
                ></el-table-column>
                <el-table-column
                  label="纬度"
                  prop="latitude"
                  align="left"
                ></el-table-column>
                <el-table-column label="操作" align="left">
                  <template #default="scope">
                    <el-button class="btn" type="text" @click="delRow(scope.row)"
                      >移除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          style="text-align: right; position: absolute; bottom: 10px; right: 25px"
        >
          <el-button @click="xunJianSure">确定</el-button>
          <el-button type="primary" @click="isOK">关闭</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--  地图选点对话框-->
    <el-dialog
      :visible.sync="mapDialog"
      :modal="false"
      append-to-body
      title="地图选点"
      style="width: 100%"
    >
      <getMap
        @getLngLat="getLngLat"
        @close="mapDialog = false"
        ref="getMap"
        :Mapcenter="Mapcenter"
        style="width: 100%; height: 300px"
      ></getMap>
    </el-dialog>
    <!-- 批量巡检 -->
    <el-dialog
      :visible.sync="xunJianDialog"
      :close-on-click-modal="false"
      title="批量巡检"
      width="500px"
    >
      <el-form :inline="true" :model="piLiangForm" class="demo-form-inline">
        <el-form-item label="养护单位">
          <el-select
            v-model="piLiangForm.departmentUuid"
            filterable
            clearable
            placeholder="请选择"
            style="width: 200px"
            @change="$set(piLiangForm, 'accountUuid', '')"
          >
            <el-option
              v-for="item in yangHuList"
              :key="item.value"
              :label="item.departmentName"
              :value="item.departmentUuid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡查人员">
          <el-select
            v-model="piLiangForm.accountUuid"
            filterable
            style="width: 200px"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in peopleData"
              :key="index"
              :label="item.accountName"
              :value="item.accountUuid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡察周期">
          <el-input
            type="text"
            style="width: 200px"
            v-model="piLiangForm.inspectionCycle"
            pattern="/^[1-9]\d*$/"
          >
            <el-button slot="append"> 天 </el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="开始时间">
          <!--  HH:mm:ss datetime
                          @on-change="startTimeChange"-->
          <el-date-picker
            v-model="piLiangForm.inspectionCycleStart"
            :picker-options="startPickerOptions"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择开始时间"
            align="right"
            style="width: 200px"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="anniu">
        <el-button type="primary" @click="xunJian_sure()">确 定</el-button>
        <el-button @click="xunJianDialog = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import getMap from '@/views/components/getMap/index.vue';
import Map from '@/views/components/Maps.vue';
export default {
  name: 'DeqingBridgeAndTunnelXunchajihua',
  components: {
    getMap,
    Map
  },
  props: [],
  data() {
    return {
      form: {
        bridgeName: '',
        endTime: '',
        startTime: '',
        pageNum: 1,
        pageSize: 10
      },
      // 地图选点显示框
      mapDialog: false,
      Mapcenter: [], //传入组件的经纬度 Mapcenter:[lng,lat]
      // facList:[],
      loading: false,
      tableData: [],
      xungengForm: {}, //巡更点表单
      total: 0,
      time: [],
      bridgeUuid: '',
      bridgeData: [],
      caozuoxy: true,
      options: [],
      bianhaoData: [], //巡更点位列表
      FormData: {
        bridgeUuid: '',
        departmentUuid: '',
        inspectionCycle: '',
        inspectionCycleStart: ''
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },
          {
            text: '明天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },
          {
            text: '一周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }
        ]
      },
      ascriptionName: '', //区域

      multipleSelection: [],
      xunJianDialog: false,
      piLiangForm: {
        // accountUuid: '',//人员
      },
      peopleData: [], //批量人员
      yangHuList: [], // 养护单位
      peopleList: [], //部门下人员
      startPickerOptions: {
        disabledDate: (date) => {
          return date && date.valueOf() < Date.now();
        }
      }
    };
  },
  watch: {
    'FormData.departmentUuid': function (newData) {
      if (newData) {
        // console.log('newData', newData);
        this.getDepartmentPeople(newData).then((res) => {
          this.peopleList = res;
        });
        // console.log(this.peopleList);
      } else {
        // console.log(111);
        this.peopleList = [];
      }
    },
    'piLiangForm.departmentUuid': function (newData) {
      if (newData) {
        this.getDepartmentPeople(newData).then((res) => {
          this.peopleData = res;
        });
      } else {
        this.peopleData = [];
      }
    }
  },
  mounted() {
    this.getBiBridgeBoPage();
    this.tableReq();
    this.getDepartment();
  },

  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection);
    },
    async xunJianClick() {
      if (this.multipleSelection.length > 0) {
        // console.log(this.$store.state.userintfo);
        // const res = await this.$api.sendGet('/accountInfo/getAccountInfoByDepartmentUuid', { departmentUuid: this.$store.state.userintfo.departmentUuid });
        // this.peopleData = res.data.list
        this.xunJianDialog = true;
      } else {
        this.$alert('你未选择设施, 请选择', '提示', {
          confirmButtonText: '确定',
          callback: (action) => {}
        });
      }
    },
    async xunJian_sure() {
      if (this.piLiangForm.departmentUuid) {
        let bridgeUuidList = [];
        this.multipleSelection.map((item) => {
          bridgeUuidList.push(item.bridgeUuid);
        });
        // console.log(bridgeUuidList, this.piLiangForm);
        let data = {
          accountUuid: this.piLiangForm.accountUuid,
          bridgeUuidList,
          departmentUuid: this.piLiangForm.departmentUuid,
          inspectionCycle: this.piLiangForm.inspectionCycle,
          inspectionCycleStart: this.piLiangForm.inspectionCycleStart
        };
        // console.log(data);
        const res = await this.$api.sendPost(
          '/biBindingBridgePeople/insertBiBindingBridgePeople',
          data
        );
        if (res.errcode == 0) {
          this.$message.success(res.errmsg);
          this.xunJianDialog = false;
          this.$refs.multipleTable.clearSelection();
          this.tableReq();
        }
      } else {
        this.$alert('你未选择单位, 请选择', '提示', {
          confirmButtonText: '确定',
          callback: (action) => {}
        });
      }
    },
    async tableReq(page) {
      this.loading = true;
      if (page) {
        this.form.pageNum = page;
      }
      let data = {
        ...this.form
      };
      // console.log(data);
      const res = await this.$api.sendPost('/patrol/getPatrol', data);
      this.loading = false;
      // console.log(res);
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.tableData = res.data.list;
          this.total = res.data.total;
        } else {
          this.tableData = [];
        }
      }
    },
    // 分页器----新每页条数
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.tableReq(1);
    },
    // 分页器-----新当前页
    handleCurrentChange(val) {
      this.form.pageNum = val;
      this.tableReq();
    },
    //时间选择
    timeChange(e) {
      let time = JSON.parse(JSON.stringify(e));
      if (time != undefined && time.length > 0) {
        this.form.beginTime = time[0];
        this.form.endTime = time[1];
      } else {
        this.form.beginTime = '';
        this.form.endTime = '';
      }
    },
    // 设施名称选择
    async bridgeChange(e) {
      if (e != '') {
        let add = this.bridgeData.find((item) => {
          return e == item.bridgeUuid;
        });
        this.form.bridgeName = add.bridgeName;
      } else {
        this.form.bridgeName = '';
      }
    },
    async bridgeChanges(e) {
      // console.log(e);
      if (e != '') {
        let add = this.bridgeData.find((item) => {
          return e == item.bridgeUuid;
        });
        // console.log(add);
        this.FormData.departmentUuid = add.departmentUuid;
        this.FormData.inspectionCycle = add.inspectionCycle;
        this.FormData.inspectionCycleStart = add.inspectionCycleStart;
        this.GetXunGengList();
      } else {
        this.FormData.departmentUuid = '';
        this.FormData.inspectionCycle = '';
        this.FormData.inspectionCycleStart = '';
      }
    },
    //获取巡更点信息
    async GetXunGengList() {
      // console.log(this.FormData.bridgeUuid);
      let bridgeUuid = this.FormData.bridgeUuid;
      const res = await this.$api.sendPost('/patrol/getPatrolByFacilityUuid', {
        facilityUuid: bridgeUuid,
        pageNum: 1,
        pageSize: 9999
      });
      // console.log('巡更点位列表', res);
      if (res.errcode == 0) {
        if (res.data.list != undefined && res.data.list.length > 0) {
          this.bianhaoData = res.data.list;
        } else {
          this.bianhaoData = [];
        }
      }
    },
    // 获取-设施录入信息
    async getBiBridgeBoPage() {
      let data = {
        pageNum: 1,
        pageSize: 99999
      };
      const res = await this.$api.sendPost('/biBridge/getBiBridgeBoPage', data);
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.bridgeData = res.data.list;
          this.options = res.data.list;
        } else {
          this.bridgeData = [];
          this.options = [];
        }
      }
    },
    //编辑和新增
    editRow(data) {
      // console.log(JSON.parse(JSON.stringify(data)));
      this.caozuoxy = false;
      if (data.bridgeId != undefined) {
        this.FormData = data;
        let add = this.bridgeData.find((item) => {
          return this.FormData.bridgeName == item.bridgeName;
        });
        // console.log(add);
        this.FormData.bridgeUuid = add.bridgeUuid;
        // console.log(this.FormData);
        this.GetXunGengList();
      } else {
        this.FormData = {
          bridgeUuid: '',
          departmentUuid: '',
          inspectionCycle: '',
          inspectionCycleStart: ''
        };
      }
    },
    //添加巡更点
    async postXunGeng() {
      // console.log(this.FormData);
      if (this.FormData.bridgeUuid != '') {
        var data = {
          patrolName: this.FormData.patrolName,
          latitude: this.FormData.latitude,
          longitude: this.FormData.longitude,
          facilityUuid: this.FormData.bridgeUuid
        };
        // console.log(data);
        const res = await this.$api.sendPost('/patrol/insertOrUpdatePatrol', data);
        this.GetXunGengList();
        // console.log(res);
      } else {
        alert('请输入设施');
      }
    },
    async isOK() {
      this.caozuoxy = true;
      // const res = await this.$api.sendPost('/patrol/insertOrUpdatePatrol', this.FormData);
      // console.log(res);
      this.tableReq();
    },
    quxiao() {
      this.caozuoxy = true;
      this.tableReq();
    },
    //删除
    async delRow(data) {
      // console.log(data);
      const res = await this.$api.sendGet('/patrol/delete', {
        patrolId: data.patrolId
      });
      this.GetXunGengList();
    },
    //周期
    // zhouqi() {
    // 	if (this.FormData.value22 == '天') {
    // 		return this.FormData.value22 = '周'
    // 	} else {
    // 		return this.FormData.value22 = '天'
    // 	}
    // },
    //地图
    getMapClick(data) {
      this.mapDialog = true;
      // console.log(data);
      if (data.longitude && data.latitude) {
        this.Mapcenter = [
          Number(this.FormData.longitude),
          Number(this.FormData.latitude)
        ];
      }
      // console.log(this.Mapcenter);
    },
    getLngLat(lng, lat, a) {
      this.FormData.longitude = lng;
      this.FormData.latitude = lat;
      this.FormData.position = a;
      this.$set(this.FormData, 'address', a);
      // console.log(this.ruleForm.position);
      this.mapDialog = false;
    },
    // 获取-部门名称列表
    async getDepartment() {
      let data = {
        pageSize: 99999,
        pageNum: 1
      };
      const res = await this.$api.sendPost(
        '/enterpriseDepartment/getAllEnterpriseTWO',
        data
      );
      // console.log("部门名称", res);
      if (res.errcode == 0) {
        if (res.data && res.data.length > 0) {
          this.yangHuList = res.data;
        } else {
          this.yangHuList = [];
        }
      }
    },
    // 获取部门下人员
    async getDepartmentPeople(uuid) {
      // console.log(uuid);
      let arr = [];
      let data = { departmentUuid: uuid };
      const res = await this.$api.sendGet(
        '/accountInfo/getAccountInfoByDepartmentUuidTwo',
        data
      );
      // console.log("获取部门下人员", res);
      if (res.errcode == 0) {
        if (res.data.list && res.data.list.length > 0) {
          arr = res.data.list;
        } else {
          arr = [];
        }
      }
      return arr;
    },
    async xunJianSure() {
      let data = {
        accountUuid: this.FormData.accountUuid,
        bridgeUuidList: [this.FormData.bridgeUuid],
        departmentUuid: this.FormData.departmentUuid,
        inspectionCycle: this.FormData.inspectionCycle,
        inspectionCycleStart: this.FormData.inspectionCycleStart
      };
      // console.log(data);
      const res = await this.$api.sendPost(
        '/biBindingBridgePeople/insertBiBindingBridgePeople',
        data
      );
      if (res.errcode == 0) {
        this.$message.success(res.errmsg);
        this.caozuoxy = true;
        this.tableReq();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modul-search {
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.caozuotianbiao {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.caozuotianbiao-from {
  width: 70%;
  min-height: 750px;
  background-color: #fff;
  text-align: left;
  padding: 20px;
  position: relative;
  padding-top: 60px;
  padding-left: 120px;

  .modul-top {
    position: absolute;
    left: 15px;
    top: 0;
  }
}
</style>
